// extracted by mini-css-extract-plugin
export default {"inheritColor":"styles-module__inheritColor--adfdI","TableRowHeading":"styles-module__TableRowHeading--ZpWzO","TableRowSubheading":"styles-module__TableRowSubheading--gqzQP"};